import React from 'react';
import { List, Create, SimpleForm, TextInput, Datagrid, TextField, UrlField, FunctionField, BooleanInput,ReferenceInput,SelectInput,AutocompleteInput } from 'react-admin';

export const VideoList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="title" />
      <TextField source='curso'/>
      <FunctionField // renderiza contenido personalizado
      label= "Vista previa"
      render={record=>
        record.url? (      //si record.url existe muestra el reproductor de video
          <video
          src={ record.url}
          controls
          style={{width:'200px',maxHeight:'120px',borderRadius:'8px'}}
          />
        ):(
          <span style={{ color: 'red' }}>No disponible</span>  //si no existe 
        )
      }
      />
       <UrlField source="url" />
        <TextField source="order" /> 
    </Datagrid>
  </List>
);

export const VideoCreate = (props) => (
  <Create>
    <SimpleForm >
      <TextInput source="title" label="Título del Video" />
      <TextInput source="url" label="URL del Video" />
      <TextInput source="order" label="Orden de Visualización" />
      <ReferenceInput source="courseId" reference='courses' label="Curso">
        <AutocompleteInput optionText={"title"} />
      </ReferenceInput>
      <BooleanInput source="isLocked" label="Bloqueado" />
    </SimpleForm>
</Create>
);
